import { defineMessages } from 'react-intl';

export const moreFundsMessages = defineMessages({
    tabName: {
        id: '_.outstanding_view.moreFundsTab',
        defaultMessage: 'More funds'
    }
});
